import { getOrgDealflow } from 'api/dealflow.api';
import { getUserOrgDeals } from 'api/deals.api';
import { getOrgInvestors } from 'api/investors.api';
import { getOrgTeams } from 'api/teams.api';
import { handleToggleExpandAllStageCards } from 'components/global/_helpers/board.events';
import { $filter, $list, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetInvestorOptionsData = async () => {
  $view.update({ isTabLoading: true });
  try {
    const [{ data: investorData }, { data: dealData }, { data: teamData }] = await Promise.all([
      getOrgInvestors(),
      getUserOrgDeals(),
      getOrgTeams(),
    ]);

    const investorOptions = investorData.map((investor) => ({
      label: investor.investorName,
      value: `${investor.recordType}-${investor.investorId}`,
    }));

    const dealOptions = dealData.map((deal) => ({
      label: deal.name,
      value: deal.id,
    }));

    const teamOptions = teamData.map((team) => ({
      label: team.name,
      value: team.id,
    }));

    $view.update({
      investorOptions,
      dealOptions,
      teamOptions,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load filter options. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isTabLoading: false }); // Fixed: should be false, not true
  }
};

export const fetchAndSetDealflowData = async ({ initView = null } = {}) => {
  if (initView) {
    $view.update({
      view: initView,
    });
  }
  $filter.reset();
  try {
    // Todo-DLS-1291: Get dealflow data from API
    const { data } = await getOrgDealflow();

    $list.update({
      data,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load dealflow data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    handleToggleExpandAllStageCards('expand');
  }
};
